var map = {
	"./car_front.jpg": 6464,
	"./car_front_roof.jpg": 5688,
	"./car_front_side.jpg": 829,
	"./car_rear.jpg": 2729,
	"./car_rear_roof.jpg": 9282,
	"./car_rear_side.jpg": 8425,
	"./car_tyre_wheel.jpg": 9286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9917;